module.exports = __webpack_public_path__ + "img/dashboard-main-mobile-en.e032bdd7.jpg";